export type ThemeCode = 'reserved-area' | 'after-sales' | 'default';
